import { Mail, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

type EmailSentConfirmationProps = {
  email: string;
  onBack: () => void;
};

const EmailSentConfirmation = ({ email, onBack }: EmailSentConfirmationProps): JSX.Element => {
  return (
    <div className="flex w-full flex-1 flex-col justify-center rounded-2xl bg-white p-10 shadow-xl">
      <div className="flex flex-col gap-6">
        {/* Success icon */}
        <div className="mb-2 flex justify-center">
          <div className="rounded-full bg-purple-50 p-4">
            <CheckCircle2 className="size-12 text-purple-600" />
          </div>
        </div>

        {/* Header */}
        <div className="mb-2 text-center">
          <h2 className="mb-3 text-2xl font-bold">
            Verifica tu Correo
          </h2>
          <p className="leading-relaxed text-gray-600">
            Hemos enviado un correo electrónico a:
          </p>
        </div>

        {/* Email display */}
        <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-center">
          <div className="flex items-center justify-center gap-2">
            <Mail className="size-5 text-purple-600" />
            <p className="font-semibold text-gray-800">
              {email}
            </p>
          </div>
        </div>

        {/* Instructions */}
        <div className="px-4 text-center">
          <p className="leading-relaxed text-gray-600">
            Por favor revisa tu bandeja de entrada y haz clic en el enlace para completar tu registro.
          </p>
        </div>

        {/* Back button */}
        <Button
          onClick={onBack}
          variant="outline"
          size="lg"
          className="mt-2 w-full"
        >
          Volver
        </Button>

        {/* Help text */}
        <p className="mt-2 text-center text-sm text-gray-500">
          ¿No recibiste el correo? Revisa tu carpeta de spam o intenta de nuevo.
        </p>
      </div>
    </div>
  );
};

export default EmailSentConfirmation;
